import { formatDateStringForApi } from "@flixbus-phx/marketplace-common";
import { RideFilter } from "../../../../state/useRideFilter/useRideFilter";

export default (rideFilter: RideFilter, dateTime: string, lineId: string, departureStationId: string): RideFilter => {
  const date = dateTime.split("T")[0];
  const time = dateTime.split("T")[1];

  return {
    ...rideFilter,
    lineId,
    departureStationId,
    departureTime: time,
    period: {
      startDate: formatDateStringForApi(date),
      endDate: formatDateStringForApi(date),
    },
  };
};
